import { Programming } from '../../models/programming';
import { getProgrammingScheduleDisplay, getTrackingStatusLabel } from '../../shared/utils/torre-tracking-utils';

export type TorreCompactSortKey =
    | 'placa'
    | 'prevCheg'
    | 'status'
    | 'prazo';

export type SortDirection = 'asc' | 'desc';

export function sortTorreCompactRows(
    rows: Programming[],
    key: TorreCompactSortKey,
    direction: SortDirection
): Programming[] {
    const factor = direction === 'asc' ? 1 : -1;
    const sorted = [...rows].sort((a, b) => {
        let cmp = 0;
        switch (key) {
            case 'placa':
                cmp = (a.mainVehiclePlateName ?? '').localeCompare(b.mainVehiclePlateName ?? '', 'pt-BR');
                break;
            case 'prevCheg': {
                const da = a.expectedDestinationArrivalAt ?? a.expectedArrivalTime ?? '';
                const db = b.expectedDestinationArrivalAt ?? b.expectedArrivalTime ?? '';
                cmp = da.localeCompare(db);
                break;
            }
            case 'status':
                cmp = getTrackingStatusLabel(a.status).localeCompare(getTrackingStatusLabel(b.status), 'pt-BR');
                break;
            case 'prazo': {
                const sa = getProgrammingScheduleDisplay(a).minutesDiff ?? 999999;
                const sb = getProgrammingScheduleDisplay(b).minutesDiff ?? 999999;
                cmp = sa - sb;
                break;
            }
            default:
                cmp = 0;
        }
        if (cmp === 0) {
            cmp = (a.id ?? '').localeCompare(b.id ?? '');
        }
        return cmp * factor;
    });
    return sorted;
}

export function filterTorreRowsByQuickSearch(rows: Programming[], query: string): Programming[] {
    const q = query.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(p => {
        const haystack = [
            p.mainVehiclePlateName,
            p.driverName,
            p.clientName,
            p.originReferenceName,
            p.destinationReferenceName,
            p.productName,
            getTrackingStatusLabel(p.status),
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
        return haystack.includes(q);
    });
}
